import React, { useState } from 'react';
import { Navigate, useNavigate } from 'react-router-dom';
import { useAuth } from '../../AuthContext';
import api from '../../utils/api';
import { PartnerEndpoints } from '../../utils/endpoints';
import AuthLayout from './AuthLayout';
import { Alert, Button, FormField } from '../ui';

const ForcePasswordChange = () => {
  const [oldPassword, setOldPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { authData } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (newPassword !== confirmPassword) {
      return setError('New passwords do not match.');
    }

    setLoading(true);
    setError('');

    try {
      await api.put(PartnerEndpoints.changePassword, {
        old_password: oldPassword,
        new_password: newPassword,
      });
      navigate('/layout');
    } catch (err) {
      if (err.response?.status === 422) {
        setError('Incorrect current password.');
      } else {
        setError('Something went wrong. Please try again.');
      }
    } finally {
      setLoading(false);
    }
  };

  if (!authData?.token) return <Navigate to="/" replace />;

  return (
    <AuthLayout
      title="Set your password"
      subtitle="Set a new password before continuing. Use the temporary password issued when your account was created."
    >
      <form onSubmit={handleSubmit}>
        {error && (
          <Alert variant="danger" className="mb-4">
            {error}
          </Alert>
        )}

        <FormField label="Current (temporary) password" htmlFor="old-password" required>
          <input
            type="password"
            id="old-password"
            className="form-control"
            placeholder="Temporary password"
            value={oldPassword}
            onChange={(e) => setOldPassword(e.target.value)}
            required
          />
        </FormField>

        <FormField label="New password" htmlFor="new-password" required>
          <input
            type="password"
            id="new-password"
            className="form-control"
            placeholder="New password"
            value={newPassword}
            onChange={(e) => setNewPassword(e.target.value)}
            required
          />
        </FormField>

        <FormField label="Confirm new password" htmlFor="confirm-password" required>
          <input
            type="password"
            id="confirm-password"
            className="form-control"
            placeholder="Confirm new password"
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
            required
          />
        </FormField>

        <Button type="submit" size="lg" loading={loading} className="w-full">
          Set new password
        </Button>
      </form>
    </AuthLayout>
  );
};

export default ForcePasswordChange;
